import { render, staticRenderFns } from "./DetailsList.vue?vue&type=template&id=3e9092a4&scoped=true&"
import script from "./DetailsList.vue?vue&type=script&lang=js&"
export * from "./DetailsList.vue?vue&type=script&lang=js&"
import style0 from "./DetailsList.vue?vue&type=style&index=0&id=3e9092a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9092a4",
  null
  
)

export default component.exports